const DB_NAME = 'suivi-btp-offline';
const DB_VERSION = 1;

const STORE_QUEUE = 'offlineQueue';
const STORE_PHOTOS = 'offlinePhotos';

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_QUEUE)) {
        db.createObjectStore(STORE_QUEUE, { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(STORE_PHOTOS)) {
        db.createObjectStore(STORE_PHOTOS, { keyPath: 'id', autoIncrement: true });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

function tx(storeName, mode = 'readonly') {
  return openDB().then((db) => {
    const transaction = db.transaction(storeName, mode);
    const store = transaction.objectStore(storeName);
    return { store, transaction, db };
  });
}

function promisify(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// ---- Queue Actions (POST/PUT/DELETE) ----

export async function queueAction(action) {
  // action = { method, url, body, headers, timestamp, meta }
  const { store } = await tx(STORE_QUEUE, 'readwrite');
  return promisify(store.add({
    ...action,
    timestamp: Date.now(),
  }));
}

export async function getQueue() {
  const { store } = await tx(STORE_QUEUE, 'readonly');
  return promisify(store.getAll());
}

export async function getQueueCount() {
  const { store } = await tx(STORE_QUEUE, 'readonly');
  return promisify(store.count());
}

export async function removeAction(id) {
  const { store } = await tx(STORE_QUEUE, 'readwrite');
  return promisify(store.delete(id));
}

export async function clearQueue() {
  const { store } = await tx(STORE_QUEUE, 'readwrite');
  return promisify(store.clear());
}

// ---- Offline Photos ----

export async function storePhoto({ tacheId, crId, lot, blob, filename }) {
  const { store } = await tx(STORE_PHOTOS, 'readwrite');
  return promisify(store.add({
    tacheId,
    crId,
    lot,
    blob,
    filename,
    timestamp: Date.now(),
  }));
}

export async function getPhotosForTask(tacheId) {
  const { store } = await tx(STORE_PHOTOS, 'readonly');
  const all = await promisify(store.getAll());
  return all.filter((p) => p.tacheId === tacheId);
}

export async function getAllPendingPhotos() {
  const { store } = await tx(STORE_PHOTOS, 'readonly');
  return promisify(store.getAll());
}

export async function getPendingPhotosCount() {
  const { store } = await tx(STORE_PHOTOS, 'readonly');
  return promisify(store.count());
}

export async function removePhoto(id) {
  const { store } = await tx(STORE_PHOTOS, 'readwrite');
  return promisify(store.delete(id));
}

export async function clearPhotos() {
  const { store } = await tx(STORE_PHOTOS, 'readwrite');
  return promisify(store.clear());
}
